export default {
  // Search box
  searchPlaceholder: "Search currency abbreviation or token contract address",

  // Contract info prompt
  notFoundData:
    "No data matching the search content found, please correct and retry",

  // Currency options
  all: "All",
  commonCurrencies: "Common Currencies",
  contractTokens: "Contract Tokens",

  // Success message
  currencyModifiedSuccess: "Currency modified successfully",
};
